var React = require('react');

function ShapeLg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M177.098 625.356C136.834 585.772 104.673 534.104 76.4849 484.739C26.048 396.303 -23.6584 291.232 14.1007 196.856C45.4036 118.759 127.224 74.7156 205.341 43.6467C304.113 4.47197 420.187 -23.1765 513.327 28.4434C564.175 56.616 600.712 104.823 631.116 154.388C698.198 263.848 723.567 397.705 636.186 504.125C587.644 558.422 529.336 614.38 466.922 652.054C413.674 684.199 349.476 702.635 288.623 689.435C245.109 680.023 208.631 656.415 177.098 625.356Z","fill":"currentColor"}));
}

ShapeLg.defaultProps = {"width":"599","height":"694","viewBox":"0 0 599 694","fill":"none"};

module.exports = ShapeLg;

ShapeLg.default = ShapeLg;
